import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button, Input, message, Tag, Icon } from 'antd';
import {
  InputContainer,
  ModalTagContainer,
  ShortMessageCheckbox,
  TestMessageModal,
} from '../styles';
import {
  TestShortMsgCheckIcon,
  TestShortMsgWarnIcon,
  TestShortMsgSuccessIcon,
  TestShortMsgerrorIcon,
} from '../../../images/svgIcons';
import {
  sendTestMessage,
  sendQAReadyTestMsg,
  sendPublishedTestMsg,
} from '../../../utils/services/shortMessageTemplateAPI';
import { REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL } from './translationValues';
import { IS_WHATSAPP_ENABLED } from '../../../utils/helper';

/* This component allows to get multiple mobile numbers and send test messages to multiple channels
  Child Components: 
    *************
*/

const NAMESPACES = ['REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL'];
class SendTestMessageModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      activeTabs: [],
      inputValue: '',
      isTestingMsg: false,
      numbers: [],
    };
  }

  componentDidMount = async () => {
    const { isWhatsappEmpty, isSMSEmpty, isCallEmpty } = this.props;
    const defaultActiveList = [];
    if (IS_WHATSAPP_ENABLED && !isWhatsappEmpty) defaultActiveList.push(0);
    if (!isSMSEmpty) defaultActiveList.push(1);
    if (!isCallEmpty) defaultActiveList.push(2);
    this.setState({ activeTabs: defaultActiveList });
  };

  toggleActiveTab = tabId => {
    let activeTabs = this.state.activeTabs;
    if (activeTabs.includes(tabId)) {
      let newVar = activeTabs.filter(value => value !== tabId);
      this.setState({ activeTabs: newVar });
    } else {
      this.setState({ activeTabs: [...this.state.activeTabs, tabId] });
    }
  };

  renderChannels = (tabId, channel, isEmpty) => {
    const { activeTabs } = this.state;
    const { t } = this.props;
    return (
      <div
        className={activeTabs.includes(tabId) ? 'Checkbox Slide-Effect' : 'Checkbox'}
        onClick={() =>
          isEmpty
            ? message.error(
                channel +
                  ' ' +
                  t(
                    REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.EMPTY_ERROR_MESSAGE.key,
                    REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.EMPTY_ERROR_MESSAGE.value,
                  ),
              )
            : this.toggleActiveTab(tabId)
        }
      >
        <span>{channel}</span>
        {!isEmpty && activeTabs.includes(tabId) && (
          <div className="Check">
            <Icon component={TestShortMsgCheckIcon} />
          </div>
        )}
      </div>
    );
  };

  renderChannelResp = (tabId, channel) => {
    const { activeTabs, isLoading, whatsappResp, smsResp, callResp } = this.state;
    let channelResp =
      tabId === 0 && IS_WHATSAPP_ENABLED ? whatsappResp : tabId === 1 ? smsResp : tabId === 2 ? callResp : undefined;
    let isErrorOrSuccess;
    let resStatus = channelResp?.status;
    if (resStatus) {
      const hasSuccess = resStatus.includes('success');
      const hasError = resStatus.includes('error');
      isErrorOrSuccess = hasSuccess && hasError
        ? 'warning'
        : hasSuccess
        ? 'success'
        : hasError
        ? 'error'
        : '';
    }
    return (
      activeTabs.includes(tabId) && (
        <div className="Checkbox-Wrapper">
          <div className="Checkbox Slide-Effect">
            <span>{channel}</span>
            <div className="Check">
              {isLoading ? (
                <Icon
                  type={'loading'}
                  style={{
                    backgroundColor: '#e6e6e6',
                    color: '#000',
                    padding: 3,
                    borderRadius: '50%',
                  }}
                />
              ) : (
                <Icon
                  component={
                    isErrorOrSuccess === 'error'
                      ? TestShortMsgerrorIcon
                      : isErrorOrSuccess === 'success'
                      ? TestShortMsgSuccessIcon
                      : TestShortMsgWarnIcon
                  }
                />
              )}
            </div>
          </div>
          {channelResp &&
            channelResp?.status?.length > 0 &&
            channelResp.status.map((respStatus, i) => (
              <>
                <p
                  className="Message"
                  style={{
                    color: respStatus === 'success' ? 'green' : 'red',
                  }}
                >
                  {channelResp.resp[i]}
                </p>
                <p className="Numbers">{channelResp.numbers[i] + ' '}</p>
              </>
            ))}
        </div>
      )
    );
  };

  handleInputFocus = () => {
    this.setState({
      borderVisibility: true,
    });
  };

  handleInputOutofFocus = () => {
    this.handleInputConfirm();
    this.setState({
      borderVisibility: false,
    });
  };

  handleInputChange = e => {
    this.setState({ inputValue: e.target.value, borderVisibility: true });
  };

  handleRemoveNum = removedTag => {
    const numbers = this.state.numbers.filter(tag => tag !== removedTag);
    this.setState({ numbers });
  };

  handleInputConfirm = () => {
    const { inputValue, numbers } = this.state;
    const { t } = this.props;
    let trimedTag = inputValue.trim().replace(/\s/g, '');
    if (trimedTag.length > 0) {
      let isValidPhoneNumber;
      if (trimedTag.match(/^(\+\d{1,3}[- ]?)?\d{10}$/) && !trimedTag.match(/0{5,}/)) {
        isValidPhoneNumber = true;
      } else {
        isValidPhoneNumber = false;
      }
      if (!isValidPhoneNumber) {
        message.error(
          t(
            REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.INVALID_MOBILE_NUMBER_ERROR_MESSAGE.key,
            REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.INVALID_MOBILE_NUMBER_ERROR_MESSAGE.value,
          ),
        );
        return;
      }
      let exists = numbers.some(tag => tag.toLowerCase() === trimedTag.toLowerCase());
      if (!exists) {
        numbers.push(trimedTag);
      } else {
        message.error(
          t(
            REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.MOBILE_NUMBER_ALREADY_EXISTS_ERROR_MESSAGE.key,
            REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.MOBILE_NUMBER_ALREADY_EXISTS_ERROR_MESSAGE.value,
          ),
        );
      }
    }
    this.setState({
      numbers,
      inputValue: '',
    });
  };

  getVariableList = varList => {
    let varValue;
    let varArray = [];
    varList.map(variable => {
      varValue = {
        name: variable.name,
        value: variable.defaultValue,
      };
      varArray.push(varValue);
    });
    return varArray;
  };

  tryAgainToSendTestMsg = () => {
    this.setState({ whatsappResp: [], smsResp: [], callResp: [] });
    this.sendTestMessage();
  };

  sendTestMessage = () => {
    const { tempDetails, variableList, currentEnv, t } = this.props;
    const { numbers, activeTabs } = this.state;
    if (numbers.length > 0) {
      let whatsappResp = {
        status: [],
        resp: [],
        numbers: [],
      };
      let smsResp = {
        status: [],
        resp: [],
        numbers: [],
      };
      let callResp = {
        status: [],
        resp: [],
        numbers: [],
      };
      this.setState({
        isLoading: true,
        isTestingMsg: true,
      });
      if (this.state.isTestingMsg) {
        this.setState({ isLoading: false, isTestingMsg: false });
        return false;
      }
      numbers.map(num => {
        activeTabs.map(async tabId => {
          let payload = {};
          payload.messageId = tempDetails?.id;
          payload.toNumber = num;
          let channel = IS_WHATSAPP_ENABLED && tabId === 0 ? 'whatsapp' : tabId === 1 ? 'sms' : tabId === 2 ? 'call' : '';
          payload.variables = JSON.parse(
            JSON.stringify(
              this.getVariableList(
                IS_WHATSAPP_ENABLED && tabId === 0
                  ? variableList.whatsappVariables
                  : tabId === 1
                  ? variableList.smsVariables
                  : tabId === 2
                  ? variableList.callVariables
                  : '',
              ),
            ),
          );
          let response;
          if (currentEnv === 'testing') {
            payload.messageId = tempDetails.messageId;
            response = await sendQAReadyTestMsg(channel, payload);
          } else if (currentEnv === 'publish') {
            payload.messageId = tempDetails.messageId;
            response = await sendPublishedTestMsg(channel, payload);
          } else {
            response = await sendTestMessage(channel, payload);
          }
          if (response) {
            this.setState({
              isLoading: false,
            });
            let respOfKey =
              IS_WHATSAPP_ENABLED && tabId === 0 ? whatsappResp : tabId === 1 ? smsResp : tabId === 2 ? callResp : '';
            if (response && response.errors && response.errors.length > 0) {
              respOfKey.status.push('error');
              respOfKey.resp.push(response.errors[0].description);
            } else {
              respOfKey.status.push('success');
              respOfKey.resp.push(
                tabId === 2 ? t(
                  REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.VOICE_MESSAGE_SENT_SUCCESS_MESSAGE.key,
                  REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.VOICE_MESSAGE_SENT_SUCCESS_MESSAGE.value,
                ) :
                  t(
                    REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.TEST_MESSAGE_SENT_SUCCESS_MESSAGE.key,
                    REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.TEST_MESSAGE_SENT_SUCCESS_MESSAGE.value,
                  ),
              );
            }
            respOfKey.numbers.push(num);
            this.setState({ whatsappResp, smsResp, callResp });
          }
        });
      });
    } else {
      message.error(
        t(
          REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.EMPTY_MOBILE_NUMBER_INPUT_ERROR_MESSAGE.key,
          REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.EMPTY_MOBILE_NUMBER_INPUT_ERROR_MESSAGE.value,
        ),
      );
    }
  };

  render() {
    const { t, onCancel, isWhatsappEmpty, isSMSEmpty, isCallEmpty } = this.props;
    const {
      isLoading,
      activeTabs,
      isTestingMsg,
      inputValue,
      borderVisibility,
      numbers,
    } = this.state;

    return (
      <TestMessageModal
        width="600px"
        centered
        maskClosable={false}
        visible={true}
        onCancel={() => onCancel(false)}
        title={t(
          REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SELECT_A_CHANNEL_ERROR_MESSAGE.key,
          REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SELECT_A_CHANNEL_ERROR_MESSAGE.value,
        )}
        footer={[
          activeTabs.length === 0 && (
            <p className="ErrorMsg">
              {t(
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SEND_TEST_MESSAGE.key,
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SEND_TEST_MESSAGE.value,
              )}
            </p>
          ),
          <div>
            <Button key="back" onClick={() => onCancel(false)}>
              {t(
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.CANCEL_SEND_TEST_MESSAGE_BUTTON.key,
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.CANCEL_SEND_TEST_MESSAGE_BUTTON.value,
              )}
            </Button>
            {!isLoading && (
              <Button
                key="Send Test Message"
                type="primary"
                onClick={() =>
                  isTestingMsg ? this.tryAgainToSendTestMsg() : this.sendTestMessage()
                }
                disabled={activeTabs.length === 0 ? true : false}
              >
                {isTestingMsg
                  ? t(
                      REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.TRY_AGAIN_TO_SEND_TEST_MESSAGE.key,
                      REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.TRY_AGAIN_TO_SEND_TEST_MESSAGE.value,
                    )
                  : t(
                      REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SEND_TEST_MESSAGE.key,
                      REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SEND_TEST_MESSAGE.value,
                    )}
              </Button>
            )}
          </div>,
        ]}
      >
        {!isTestingMsg && (
          <ShortMessageCheckbox>
            {IS_WHATSAPP_ENABLED && this.renderChannels(
              0,
              t(
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.WHATSAPP_MESSAGE_CHANNEL_NAME.key,
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.WHATSAPP_MESSAGE_CHANNEL_NAME.value,
              ),
              isWhatsappEmpty,
            )}
            {this.renderChannels(
              1,
              t(
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SMS_CHANNEL_NAME.key,
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SMS_CHANNEL_NAME.value,
              ),
              isSMSEmpty,
            )}
            {this.renderChannels(
              2,
              t(
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.VOICE_MESSAGE_CHANNEL_NAME.key,
                REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.VOICE_MESSAGE_CHANNEL_NAME.value,
              ),
              isCallEmpty,
            )}
          </ShortMessageCheckbox>
        )}
        {isTestingMsg && (
          <>
            <ShortMessageCheckbox errorCase={isTestingMsg} length={activeTabs.length}>
              {this.renderChannelResp(
                0,
                t(
                  REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.WHATSAPP_MESSAGE_CHANNEL_NAME.key,
                  REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.WHATSAPP_MESSAGE_CHANNEL_NAME.value,
                ),
              )}
              {this.renderChannelResp(
                1,
                t(
                  REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SMS_CHANNEL_NAME.key,
                  REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SMS_CHANNEL_NAME.value,
                ),
              )}
              {this.renderChannelResp(
                2,
                t(
                  REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.VOICE_MESSAGE_CHANNEL_NAME.key,
                  REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.VOICE_MESSAGE_CHANNEL_NAME.value,
                ),
              )}
            </ShortMessageCheckbox>
            {isLoading && (
              <>
                <Icon type="loading" />
                <p className="Sending-Icon-Text">
                  {activeTabs.length > 1
                    ? t(
                        REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SENDING_TEST_MESSAGE.key,
                        REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SENDING_TEST_MESSAGE.value,
                      )
                    : t(
                        REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SENDING_TEST_MESSAGES.key,
                        REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SENDING_TEST_MESSAGES.value,
                      )}{' '}
                </p>
              </>
            )}
          </>
        )}
        {!isTestingMsg && (
          <ModalTagContainer border={borderVisibility}>
            {numbers?.length > 0 &&
              numbers?.map((num, index) => {
                return (
                  <Tag
                    className="edit-tag"
                    key={num}
                    closable={true}
                    onClose={() => this.handleRemoveNum(num)}
                    color="#df4c35"
                  >
                    <span>{num}</span>
                  </Tag>
                );
              })}
            <InputContainer>
              <Input
                name="mobileNumber"
                ref={this.saveInputRef}
                type="text"
                className="tag-input"
                value={inputValue}
                onFocus={this.handleInputFocus}
                onChange={this.handleInputChange}
                onBlur={this.handleInputOutofFocus}
                onPressEnter={this.handleInputConfirm}
                placeholder={t(
                  REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SEND_TEST_MESSAGE_PLACEHOLDER.key,
                  REQUEST_FOR_APPROVAL_AND_PUBLISH_MODAL.SEND_TEST_MESSAGE_PLACEHOLDER.value,
                )}
                autoComplete={'off'}
              />
            </InputContainer>
          </ModalTagContainer>
        )}
      </TestMessageModal>
    );
  }
}

export default withTranslation(NAMESPACES)(SendTestMessageModal);
